import { render, staticRenderFns } from "./CoachVideoCard.vue?vue&type=template&id=95f87c9c&scoped=true"
import script from "./CoachVideoCard.vue?vue&type=script&lang=js"
export * from "./CoachVideoCard.vue?vue&type=script&lang=js"
import style0 from "./CoachVideoCard.vue?vue&type=style&index=0&id=95f87c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f87c9c",
  null
  
)

export default component.exports